import Date from '../../../../components/Date/Date'
import { formatPrice } from '../../../../utils/common'

function PaymentDetailsTableRow({row}: any) {
  return (
    <tr key={row.id}>
      <td>{row.poNumber}</td>
      <td><Date date={row.poDate} /></td>
      <td>{row.supplierName}</td>
      <td>{row.companyName}</td>
      <td className='text-end'>{row.makePayment ? formatPrice(row.makePayment,false) : '-'}</td>
      <td className='text-end'>{row.totalAmount ? formatPrice(row.totalAmount,false) : '-'}</td>
      <td className='text-end'>{row.paidAmount ? formatPrice(row.paidAmount,false) : '-'}</td>
      <td className='text-end'>{row.remainingAmount ? formatPrice(row.remainingAmount,false) : '-'}</td>
    </tr>
  )
}

export default PaymentDetailsTableRow
